export default __webpack_public_path__ + "static/2-5c041c5c3f5c96e2511bf0a1227ee541.png";